import { formatDateTimeDisplay } from '../constants/hrmsAttendanceDetails.constants'
import { REGULARIZATION_REVIEW_TEXTS } from '../constants/hrmsRegularizationReview.constants'
import type { RegularizationStatus } from '../types/hrmsAttendanceDetails.types'

interface RequestSubmissionDetailsProps {
  reason: string
  requestedAt: string
  status: RegularizationStatus
}

export function RequestSubmissionDetails({
  reason,
  requestedAt,
  status,
}: RequestSubmissionDetailsProps) {
  return (
    <div className="bg-slate-50/90 rounded-xl p-4 border border-slate-200 shadow-xs space-y-3 min-w-0">
      <div className="flex items-center justify-between gap-2 border-b border-slate-200/80 pb-2.5">
        <span className="text-xs font-bold uppercase tracking-wider text-slate-500">
          REQUEST SUBMISSION DETAILS
        </span>

        {status === 'Pending Approval' && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-700 border border-amber-200 whitespace-nowrap">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
            Pending Approval
          </span>
        )}
        {status === 'Approved' && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-semibold text-emerald-700 border border-emerald-200 whitespace-nowrap">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
            Approved
          </span>
        )}
        {status === 'Rejected' && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-semibold text-red-700 border border-red-200 whitespace-nowrap">
            <span className="h-1.5 w-1.5 rounded-full bg-red-500 shrink-0" />
            Rejected
          </span>
        )}
      </div>

      <div className="space-y-2.5 text-xs">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-2 min-w-0">
          <span className="text-slate-500 font-medium shrink-0">Reason for Correction:</span>
          <span className="text-slate-800 italic break-words [overflow-wrap:anywhere] min-w-0 sm:text-right">
            “{reason}”
          </span>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 border-t border-slate-200/60 pt-2">
          <span className="text-slate-500 font-medium shrink-0">Requested On:</span>
          <span className="font-bold text-slate-800 sm:text-right">
            {formatDateTimeDisplay(requestedAt)}
          </span>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 border-t border-slate-200/60 pt-2">
          <span className="text-slate-500 font-medium shrink-0">Permission Note:</span>
          <span className="text-slate-500 font-normal sm:text-right">
            {REGULARIZATION_REVIEW_TEXTS.permissionNote}
          </span>
        </div>
      </div>
    </div>
  )
}
